import _ from 'lodash';

const MAX_BYTE_SIZE = 1024;

const _totalUploadSize = (images) => {
  if (_.size(images) === 0 || !images.every((img) => img.compressed === true)) return 0;

  return images.reduce((acc, val) => {
    return acc + parseInt(val.size || '0') / MAX_BYTE_SIZE;
  }, 0);
};

const isValidUpload = (images) => _totalUploadSize(images) < MAX_BYTE_SIZE;

// eslint-disable-next-line import/prefer-default-export
export const lsUploadPhotosHelper = {
  isValidUpload,
};
